// portal.corrprocanada.com
// Website/API/Cognito are separate from prod; data buckets point at the
// same underlying resources as aip.corrprocanada.com (DATA_STAGE = 'prod').
const DATA_STAGE = 'prod';
const URL = 'https://api.portal.corrprocanada.com';
const WS = 'wss://ws.portal.corrprocanada.com';
const APP_BUCKET = 'portal.corrprocanada.com';

const TAB_PREFIX = '';
const TAB_SUFFIX = 'Portal';

const aipurls = {
	admin: `${URL}/admin`,
	account: `${URL}/account`,
	assetview: `${URL}/assetview`,
	assetviewWS: `${WS}/assetview`,
	assetviewCorrelator: `${URL}/assetview-correlator`,
	customerusers: `${URL}/customer-users`,
	cisview: `${URL}/cisview`,
	cisviewextended: `${URL}/cisview-extended`,
	cisviewreadonly: `${URL}/cisview-readonly`,
	cisviewedits: `${URL}/cisview-edits`,
	cisviewwsstepfuncs: `${URL}/cisview-ws-stepfuncs`,
	cisviewwsstepfuncsWS: `${WS}/cisview-ws-stepfuncs`,
	dashboard: `${URL}/dashboard`,
	fieldline: `${URL}/fieldline`,
	fieldlinebinary: `${URL}/fieldline-binary`,
	chargeline: `${URL}/chargeline`,
	chargelinebinary: `${URL}/chargeline-binary`,
	maps: `${URL}/maps`,
	scanline: `${URL}/scanline`,
	scanlineWorkflow: `${URL}/scanline-workflow`,
	scanlineReportV2: `${URL}/scanline-report-v2`,
	scanlineReportV2WS: `${WS}/scanline-report-v2`,
	scanlineTags: `${URL}/scanline-tags`,
	templateViewer:
		`${URL}/internal-template-viewer-2`,
	templates: `${URL}/templates`,
	scanlineReport: `${URL}/scanlineReport`,
	liveline: `${URL}/liveline`,
	settings: `${URL}/settings`,
	uploaderbucket: `corrprocanada-aip-${DATA_STAGE}`,
	cisvFalconBucket: `aip-cisview-${DATA_STAGE}-falcon-files`,
	uploderbucketbasepath: `${URL}/uploader`,
	uploaderwebsocket: `${WS}/uploader`,
	uploaderbucketaccessurl: `${URL}/uploader/access`,
	falconuploaderbucketaccessurl: `${URL}/uploader/falcon-access`,
	uploaderfilesubmiturl:
		`${URL}/cisview-extended/postUploaderSubmit`,
	parseFile: `${URL}/parse-file`,
	parseFileWS: `${WS}/parse-file`,
	mlServerApi: 'https://ml.aip.corrprocanada.com/',
	mlServerLambdaApi: `${URL}/ml/`,
	downloadReport: `${URL}/dataprocessor-report`,
	notifications: `${URL}/aip-notifications`,
	viewAs: `${URL}/view-as`,
	dataIntegrity: `${URL}/dataIntegrity`,
	downloadOverridesRoot:
		`https://${APP_BUCKET}/Content/DownloadOverrides`,

	// SQS
	sqsemailscorrproonly: `${URL}/emails-corrpro-only`,

	// COGNITO
	poolid: 'cognito-idp.us-west-2.amazonaws.com/REPLACE_WITH_CLIENTPORTAL_PROD_COGNITO_POOL_ID',
	identifypoolid: 'REPLACE_WITH_CLIENTPORTAL_PROD_IDENTITY_POOL_ID',
	clientid: 'REPLACE_WITH_CLIENTPORTAL_PROD_COGNITO_CLIENT_ID',

	// BUCKETS
	bucket: `corrprocanada-aip-${DATA_STAGE}-nonversioned`,
	versionedBucket: `corrprocanada-aip-${DATA_STAGE}`,
};

export default aipurls;

export { URL, TAB_PREFIX, TAB_SUFFIX };
